<template>
  <img
    :src="url"
    class="list-image-container"
    :style="{
      width: size + 'px',
      height: size + 'px',
    }"
    onerror="this.src='https://clubs.xinmin.cn/dzclub/static/img/author.png';"
    alt=""
  />
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 150,
    },
  },
};
</script>
<style lang="less" scoped>
.list-image-container {
  display: block;
  border-radius: 5px;
  object-fit: cover;
}
</style>